export default [{
  path: '/digitalListPage',
  name: 'digitalListPage',
  component: () => import('@/views/digitalListPage/index'),
}]
